import { getAssessments, getAssessment, saveAssessment,getAllQuestionTypes  } from '../../shared/data-services/assessment-service';

export async function getListAssessment (companyId){
  const data = await getAssessments(companyId);
  return data || [ ];
};

export async function  getAssessmentsById (id){
  const data = await getAssessment(id);
  return data || [ ];
};

export async function upsertAssessment ( assessment, companyId ){
  
  const data = await saveAssessment(assessment, companyId);
  return data;
};


export async function getQuestionTypes (){
  const data = await getAllQuestionTypes();
  return data || [ ];
};
